<template>
  <a v-bind="{ href }"
    :target="blank ? '_blank' : false"
    class="button">
    <icon
      v-if="leftIcon"
      :class="iconClass"
      :pack="leftIconPack"
      :icon="leftIcon"
      :type="leftIconType"
    />
    <slot v-if="!leftIcon && !rightIcon"/>
    <span v-else><slot/></span>
    <icon
      v-if="rightIcon"
      :class="iconClass"
      :pack="rightIconPack"
      :icon="rightIcon"
      :type="rightIconType"
    />
  </a>
</template>

<script>
import * as props from '../mixins/props'

export default {

  mixins: [
    props.iconable,
  ],

  props: {
    href: String,
    blank: {
      type: Boolean,
      default: false,
    }
  }

}
</script>
